import { createSelector } from "@ngrx/store";
import { EntityTramiteStatusState, entityTramiteStatusAdapter } from "./tramite-status.state";
import { VistaUsuarioState, selectVistaUsuario } from "../../vista-usuario/vista-usuario.state";

const { selectEntities, selectAll } = entityTramiteStatusAdapter.getSelectors();

export const selectTramiteStatusState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tramiteStatus
);

export const getError = (state: EntityTramiteStatusState): Error => state.error as any;

export const getIsLoading = (state: EntityTramiteStatusState): boolean => state.isLoading;

export const selectAllTramiteStatus = createSelector(selectTramiteStatusState, selectAll);

export const selectEntitiesTramite = createSelector(
  selectTramiteStatusState,
  selectEntities
);
